<template>
  <v-row class="order-info">
    <!-- client -->
    <v-col>
      <v-card flat>
        <v-card-title>
          {{ $t('global.client') }}
        </v-card-title>
        <v-card-text>
          <b>{{ order.customer.first_name }} {{ order.customer.last_name }}</b><br>
          <div v-if="isClickAndCollectOrder(order)">
            <v-chip class="cnc">
              {{ $t('order.fulfillment_type.cnc') }}
            </v-chip>
            <br>
          </div>
          <div v-if="!isClickAndCollectOrder(order)">
            <div
              class="accent--text address-link"
              @click="showOnGoogleMaps(order.customer)"
            >
              <div>
                {{ order.customer.address }}
                <span v-if="order.customer.street_number"> {{ order.customer.street_number }}</span>
              </div>
              <div>
                {{ order.customer.postal_code }} {{ order.customer.city }} ({{ order.customer.province }})
              </div>
            </div>
            <div v-if="order.customer.doorbell">
              {{ order.customer.doorbell }}
            </div>
            <br>
            {{ $t('global.distance') }}: <b>{{ order.customer_to_store_distance }} km</b>
          </div>
          <br>
          {{ order.customer.phone }}<br>
          {{ order.customer.email }}
        </v-card-text>
      </v-card>
    </v-col>

    <!-- total -->
    <v-col>
      <v-card flat>
        <v-card-title>
          {{ $t('global.total') }}
        </v-card-title>
        <v-card-text>
          <div class="d-inline-flex">
            <v-icon>
              {{ order.payment_type === 'CREDIT_CARD' ? 'mdi-credit-card' : 'mdi-handshake' }}
            </v-icon>
            {{ order.amount_formatted }}
          </div>

          <div>
            <v-chip
              v-if="order.payment_type === 'CASH'"
              color="error"
            >
              {{ $t('order.payment.to_collect') }}
            </v-chip>
            <v-chip
              v-if="order.payment_type === 'CREDIT_CARD'"
              color="primary"
            >
              {{ $t('order.payment.already_paid') }}
            </v-chip>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- delivery -->
    <v-col>
      <v-card flat>
        <v-card-title>
          {{ $t('global.delivery') }}
        </v-card-title>
        <v-card-text>
          {{ getDeliveryDate(order.deliver_at_start) }}<br>
          <b>{{ getDeliverySlot(order.deliver_at_start, order.deliver_at_end) }}</b>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- notes -->
    <v-col>
      <v-card flat>
        <v-card-title>
          {{ $t('global.notes') }}
        </v-card-title>
        <v-card-text>
          {{ order.notes }}
        </v-card-text>
      </v-card>
    </v-col>

    <!-- status -->
    <v-col>
      <v-card flat>
        <v-card-title>
          {{ $t('global.status') }}
        </v-card-title>
        <v-card-text>
          <status-block
            :color="getColorByStatus(order.status)"
            :label="$t(`statuses.${order.status}`)"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import OrderHelper from './../Helpers/Order'
import StatusColor from './../Helpers/StatusColor'
import StatusBlock from './../UI/StatusBlock'

export default {

  components: {
    StatusBlock
  },
  props: {
    order:{
      type: Object,
      required: true
    }
  },

  methods: {
    getColorByStatus: StatusColor.getColorByOrderStatus,
    getDeliveryDate: OrderHelper.getDeliveryDate,
    getDeliverySlot: OrderHelper.getDeliverySlot,
    showOnGoogleMaps: OrderHelper.showOnGoogleMaps,
    isClickAndCollectOrder: OrderHelper.isClickAndCollectOrder,
  }
}
</script>

<style lang="scss" scoped>
.address-link {
  text-decoration: underline;
  cursor: pointer;
}

@media print {
  .order-info .v-card__title {
    font-size: 16px;
  }
}
</style>
